//Comentario necesario para codificación en UTF-8, ver Inc6743
(function() {
	var App = angular.module('pphhApp');

	App.service("wsUploadActionController", ["$mdDialog", WsUploadActionController]);
	App.controller("wsUploadDialogController", ["$scope", "$http", "$mdDialog", "$interval",
		"$window", "pphhEnv", WsUploadDialogController]);

	function WsUploadActionController($mdDialog) {
		this.performAction = performAction;


		function performAction(scope) {
			$mdDialog.show({
				clickOutsideToClose: false,
				escapeToClose: false,
				parent: angular.element(document.body),
				controller: "wsUploadDialogController",
				templateUrl: "/ws-import/wsuploadstatus-init"
			});
		}
	}

	function WsUploadDialogController($scope, $http, $mdDialog, $interval, $window, pphhEnv) {
		var self = this;

		$scope.status = [];
		$scope.currentState = null;
		$scope.timer = undefined;

		$scope.init = init;
		$scope.requestSync = requestSync;
		$scope.requestSyncStatus = requestSync;
		$scope.closeDialog = closeDialog;
		$scope.exportarReport = exportarReport;


		function init() {
			requestSyncStatus();
			$scope.timer = $interval(requestSyncStatus, 30000);
		}

		/**
		 * Callback que se invoca cuando la operación de carga se ha realizado
		 * correctamente.
		 */
		this.uploadFileSuccessCallback = function (response) {
			$scope.currentState.inProgress = true;
			var successMessage = response.data.successMessage;
			$scope.message = successMessage.message;
		};


		/**
		 * Callback que se invoca cuando se ha producido algún error durante la
		 * operación de carga.
		 */
		this.uploadFileErrorCallback = function (response) {
			$scope.currentState.inProgress = false;
			var errorMessages = response.data.errorMessages;
			var field = errorMessages[0];
			$scope.message = field.message;
		};

		function requestSyncStatus() {
			$http({
				method: "GET",
				url: "/ws-import/pphhSyncStatus"
			}).then(
				function(response) {
					$scope.status = response.data;
				}
			);

		}

		function requestSync(state) {
			$scope.currentState = state;
			state.inProgress = true;
			var request = {
				method: "POST",
				url: "/ws-import/create-task",
				params: {
					dhCode: state.euRBDCode
				}
			};

			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;			
			$http(request).then(self.uploadFileSuccessCallback, self.uploadFileErrorCallback);
		}

		function closeDialog() {
			if ($scope.timer != undefined) {
				$interval.cancel($scope.timer);
			}
			$scope.timer = undefined;
			$mdDialog.hide();

		}
		function exportarReport(activityId) {
			var url = pphhEnv.global.contextPath + "/dashboard/loadingTask/" + activityId + "/fullReport";
			$window.open(url);
		}


	}

})();